import { SkeletonAvatar } from '@/components/skeleton/AvatarSkeleton'
import { RecommendationCardBase } from './RecommendationCardBase'
import { TextSkeleton } from '@/components/skeleton/TextSkeleton'

export const RecommendationCardLoading = () => {
  return (
    <RecommendationCardBase avatar={<SkeletonAvatar size={48} />}>
      <div className="flex flex-column gap-2">
        <TextSkeleton width="60%" height={14} />
        <TextSkeleton width="100%" height={14} />
        <TextSkeleton width="45%" height={14} />

        <div className="mt-12">
          <TextSkeleton height={31} />
        </div>
      </div>
    </RecommendationCardBase>
  )
}
